import React from 'react';

import { clienteApi, Resultados } from 'src/api';
import { Contexto } from 'src/contexto';
import { nombreCompletoConNombresPrimero } from 'src/utilidades';
import { TablaDeAlumnos } from './componentes/TablaDeAlumnos';

type Alumno =
    | Resultados<'alumnosRestringidosDeClases'>['alumnos'][number]
    | Resultados<'alumnosRestringidosDeMaterial'>['alumnos'][number]
    | Resultados<'alumnosRestringidosDePuntajes'>['alumnos'][number];

type Props = {
    readonly comando:
        | 'alumnosRestringidosDeClases'
        | 'alumnosRestringidosDeMaterial'
        | 'alumnosRestringidosDePuntajes';
};

type State = {
    readonly alumnos: ReadonlyArray<Alumno>;
    readonly cargando: boolean;
};

export class RestringidosDe extends React.Component<Props, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = {
        alumnos: [],
        cargando: false,
    };

    public componentDidMount() {
        this.traerDatos();
    }

    public render() {
        return (
            <TablaDeAlumnos
                alumnos={this.state.alumnos}
                cargando={this.state.cargando}
                alPresionarRecargar={this.traerDatos}
            />
        );
    }

    private readonly traerDatos = () => {
        this.setState({ cargando: true });

        clienteApi
            .ejecutar(this.props.comando)
            .then(({ alumnos }) => {
                alumnos.sort((a, b) =>
                    nombreCompletoConNombresPrimero(a.nombre).localeCompare(
                        nombreCompletoConNombresPrimero(b.nombre),
                        'es',
                    ),
                );
                alumnos.forEach(alu => {
                    alu.cursos.sort(
                        (a, b) =>
                            a.dia - b.dia ||
                            ordenarStrings(a.bloqueHorario.horaInicio, b.bloqueHorario.horaInicio),
                    );
                });

                this.setState({ alumnos, cargando: false });
            })
            .catch(error => {
                this.setState({ cargando: false });
                this.context.mostrarModalError(error);
            });
    };
}

function ordenarStrings(a: string, b: string) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/Restringidos/RestringidosDe.tsx